module.exports = __webpack_public_path__ + "static/media/logo512.12b1dcf2.png";